import "./src/styles/global.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/inter/800.css";

import React from "react";
import { AuthProvider } from "./src/context/AuthProvider";
import PersistLogin from "./src/components/PersistLogin";
import FakeAuthToggle from "./src/components/FakeAuthToggle";


export const wrapRootElement = ({ element }) => (
	<AuthProvider>
		<PersistLogin>
			{element}
			<FakeAuthToggle />
		</PersistLogin>
	</AuthProvider>
);
